<template>
	<div class="conten">
		<el-form :model="ruleForm2"  ref="ruleForm2" label-position="left" label-width="0px"
			class="demo-ruleForm login-container">
			<h3 class="title">系统登录</h3>
			<el-form-item prop="account">
				<el-input type="text" v-model="ruleForm2.username" auto-complete="off" placeholder="账号" @keyup.enter.native="handleSubmit2('ruleForm2')"></el-input>
			</el-form-item>
			<el-form-item prop="checkPass">
				<el-input type="password" maxlength="18" v-model="ruleForm2.password" auto-complete="off" placeholder="密码" @keyup.enter.native="handleSubmit2('ruleForm2')"></el-input>
			</el-form-item>
			<el-form-item style="width:100%;">
				<el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit2('ruleForm2')"
					:loading="logining">
					登录</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	import {
		mapMutations
	} from "vuex";
	export default {
		data() {
			return {
				logining: false,
				ruleForm2: {
					username: '',
					password: ''
				},
				
			};
		},
		methods: {
			...mapMutations(['update_username', 'update_token', 'update_userInfo']),
			handleSubmit2(ev) {
				if (this.ruleForm2.username.length == 0) {
					this.$message('请输入用户名');
					return false
				}
				if (this.ruleForm2.password.length <6) {
					this.$message('请输入正确的密码');
					return false
				}
				this.httpPost("/login", this.$qs.stringify(this.ruleForm2), false).then(res => {
					if (res.code == 200) {
						this.$message.success('登录成功');
						this.update_token(res.data.token);
						this.getUserInfo()
					}
				})
			},
			//获取用户信息
			getUserInfo() {
				this.httpPost("/index").then(res => {
					if (res.code == 200) {
						this.update_userInfo(res.data);
						setTimeout(() => {
							this.$router.push('/home');
						}, 1000);
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.conten {
		width: 100%;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.login-container {
		/*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
		-webkit-border-radius: 5px;
		border-radius: 5px;
		-moz-border-radius: 5px;
		background-clip: padding-box;
		// margin: 180px auto;
		width: 350px;
		padding: 35px 35px 15px 35px;
		background: #fff;
		border: 1px solid #eaeaea;
		box-shadow: 0 0 25px #cac6c6;

		.title {
			margin: 0px auto 40px auto;
			text-align: center;
			color: #505458;
		}

		.remember {
			margin: 0px 0px 35px 0px;
		}
	}
</style>
